var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelect = function SvgSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "select_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#select_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M12 3.55 14.85.7a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L12.7 5.65q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-1.425-1.4a.86.86 0 0 1-.287-.687 1.07 1.07 0 0 1 .287-.713q.3-.3.713-.3.412 0 .712.3zM3 22.5v-7.15q0-.175.025-.35a2 2 0 0 1 .075-.325L4.975 9.35q.2-.6.725-.975T6.875 8h10.25q.65 0 1.175.375t.725.975l1.875 5.325q.05.15.075.325t.025.35v7.15q0 .625-.437 1.063A1.45 1.45 0 0 1 19.5 24q-.625 0-1.062-.437A1.45 1.45 0 0 1 18 22.5V22H6v.5q0 .625-.437 1.063A1.45 1.45 0 0 1 4.5 24q-.625 0-1.062-.437A1.45 1.45 0 0 1 3 22.5M5.8 13h12.4l-1.05-3H6.85zm1.7 6q.624 0 1.063-.437Q9 18.125 9 17.5t-.437-1.062A1.45 1.45 0 0 0 7.5 16q-.625 0-1.062.438A1.45 1.45 0 0 0 6 17.5q0 .625.438 1.063Q6.874 19 7.5 19m9 0q.625 0 1.063-.437Q18 18.125 18 17.5t-.437-1.062A1.45 1.45 0 0 0 16.5 16q-.625 0-1.062.438A1.45 1.45 0 0 0 15 17.5q0 .625.438 1.063.437.437 1.062.437M5 20h14v-5H5z"
  }))));
};
export default SvgSelect;